import React from "react";
import SlideShow from "./imageSlideElements";
import urlContain from "../../utils/urlContain";

function ImageSlide({imageSlideArray}) {
	// const array = [
	// 	"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA0oorm4_3stIaZtzwS4EfLulA80OjzXRovluOtrrsP1QAmyunnS31crPBwzbWZ65ulKU&usqp=CAU",
	// 	"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA0oorm4_3stIaZtzwS4EfLulA80OjzXRovluOtrrsP1QAmyunnS31crPBwzbWZ65ulKU&usqp=CAU",
	// 	"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA0oorm4_3stIaZtzwS4EfLulA80OjzXRovluOtrrsP1QAmyunnS31crPBwzbWZ65ulKU&usqp=CAU",
	// ];
	return (
		<SlideShow>
			<SlideShow.Slides>
				{imageSlideArray?.map((item, index) => (
					<SlideShow.EachSlideEffect key={index}>
						<SlideShow.BackgroundImage src={urlContain(item)} alt="" loading="lazy" />
					</SlideShow.EachSlideEffect>
				))}
			</SlideShow.Slides>
		</SlideShow>
	);
}

export default ImageSlide;
